<template>
  <div class="flex" v-if="teacher.length === 1">
    <div class="teacher">
      <div class="img" :style="$bgd(teacher[0].gravatar)" />
      <span>{{ teacher[0].name }}</span>
    </div>
  </div>
  <div class="flex" v-else-if="teacher.length > 1">
    <div class="teacher teacher-multiple">
      <div v-for="item in teacher" :key="item.t_id" class="img" :style="$bgd(item.gravatar)" />
    </div>
  </div>
</template>
<script>
export default {
  props: ["teacher"]
}
</script>
<style scoped lang="scss">
@import "./style.scss";
</style>